import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export const useGenerateSubscriptionEntitiesMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (
    res: recallApi.GenerateOtterSubscriptionEntitiesResponse,
  ) => void;
  onError?: (error: recallApi.GenerateOtterSubscriptionEntitiesError) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      checkout_session_id,
    }: {
      checkout_session_id: string;
    }) => {
      const response = await recallApi.generateOtterSubscriptionEntities({
        body: { checkout_session_id },
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
